module.exports = __webpack_public_path__ + "static/img/policy-header_600.e1f5cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-header_600.png
// module id = +Gl8
// module chunks = 0